import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function SectionFaq() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggleFaq = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于每日大赛的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                  openId === faq.id ? 'rotate-45' : ''
                }`}>
                  <i className={`text-foreground-500 text-lg ${openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-4 pt-0">
                  <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-4">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}